<p-sidebar [(visible)]="isOpen" position="bottom"
           [baseZIndex]="10000"
           (onShow)="doShow()"
           [style]="{height: height}">
    <ng-template pTemplate="header">
        <ng-content select="[header]"></ng-content>
    </ng-template>
    <ng-template pTemplate="footer">
        <ng-content select="[footer]"></ng-content>
    </ng-template>
    <ng-content select="[content]"></ng-content>
</p-sidebar>
